/**
 * External Dependencies
 */
import 'jquery';
jQuery.event.special.touchstart = {
  setup: function( _, ns, handle ) {
    this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
  },
};
jQuery.event.special.touchmove = {
  setup: function( _, ns, handle ) {
    this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
  },
};
jQuery.event.special.wheel = {
  setup: function( _, ns, handle ){
    this.addEventListener("wheel", handle, { passive: true });
  },
};
jQuery.event.special.mousewheel = {
  setup: function( _, ns, handle ){
    this.addEventListener("mousewheel", handle, { passive: true });
  },
};

import lozad from 'lozad';
const observer = lozad();
observer.observe();

import '@fancyapps/fancybox/dist/jquery.fancybox';
import 'slick-carousel/slick/slick.min';

import './custom';

import { config, dom, library } from '@fortawesome/fontawesome-svg-core';
import { faFacebook, faFacebookF, faInstagram, faLinkedin, faPinterest, faTwitter, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { faAngleDown, faAngleRight, faArrowRight, faBalanceScale, faBars, faCalendarAlt, faCaretLeft, faCaretRight, faCaretUp, faCheck, faChevronDown, faEnvelope, faEnvelopeOpen, faLock, faMapMarkerAlt, faPhone, faPhoneSquare, faPlay, faPlus, faPrint, faShare, faShareAlt, faShieldAlt, faStar, faTimes, faToolbox, faUser } from '@fortawesome/pro-solid-svg-icons';
config.searchPseudoElements=true;
library.add(faPhone, faPhoneSquare, faPrint, faEnvelope, faEnvelopeOpen, faMapMarkerAlt, faBars, faFacebook, faFacebookF, faTwitter, faInstagram, faYoutube, faPinterest, faLinkedin, faChevronDown, faCaretLeft, faCaretRight, faCaretUp, faArrowRight, faTimes, faShare, faShareAlt, faAngleDown, faAngleRight, faLock, faCheck, faStar, faShieldAlt, faBalanceScale, faToolbox, faPlus, faUser, faCalendarAlt), faPlay;
dom.i2svg();

// import Vue from 'vue';
// import { vueRouter, createRouter, createWebHistory } from 'vue-router'
// createRouter({
//   history: createWebHistory('/shop'),
//   routes: [
//     {
//       path: '/shop',
//       name: 'index',
//       component: Shop,
//       meta: {
//         title: 'Shop'
//       }
//     }
//   ]
// })
//
// import Shop from './views/Shop';
// import { createApp } from 'vue'
// createApp({
//   components: { Shop },
// }).mount('#shop');
